export const isEmptyString = (x: string | null): boolean => x == null || x.trim().length === 0;
